module.exports = __webpack_public_path__ + "static/media/deadfuck-promo-picture.41bed38e.jpeg";